<template>
  <v-app>
    <!-- Laptop view -->
    <v-main class="hidden-md-and-down">
      <v-row>
        <v-col cols="12" md="1" sm="1" lg="1">
          <NavMenu :username="username" />
        </v-col>
        <v-spacer />
        <v-col cols="12" md="10" sm="10" lg="10">
          <v-container>
            <div style="margin:30px 110px 30px 110px">
              <div style="max-width:100%">
                <span
                  class="font-weight-bold"
                  style="padding-top:3px;text-decoration:none;font-size:24px"
                >
                  Share</span
                >
                <v-btn style="float:right" to="/settings" fab text>
                      <v-avatar style="float:right" v-bind="attrs" v-on="on">
                        <img :src="user.data.photoURL" alt="" />
                      </v-avatar>
                    </v-btn>
                    
              </div>
              <div class="text-center mt-12">
              <p>Share your Tipppings page with your friends and connections:</p>
              <div>
              <div>
              <v-btn
            x-large
            color="#1773ea"
            :href="`https://facebook.com/sharer/sharer.php?u=https://tippings.me/${username}`"
            target="_blank"
            style="color:white"
             class="animate__animated animate__fadeInUp"
             width="420px"

          >
            <v-icon color="white" class="mr-2 px-2">mdi-facebook</v-icon>
           Share on Facebook
          </v-btn>
          </div>
          <div>
          <v-btn
            x-large
            color="green"
            :href="
              `https://wa.me/?text=I%20just%20created%20an%20account%20on%20Tippings.%20Check%20out%20my%20Tippings%20page!%20https://tippings.me/${username}`
            "
            target="_blank"
            width="420px"
            style="color:white"
            class='mt-3 animate__animated animate__fadeInUp animate__delay-1s'
          >
            <v-icon color="white" class="mr-2 px-2">mdi-whatsapp</v-icon>
          Share on WhatsApp</v-btn>
          </div>
          <div>
          <v-btn
            x-large
            color="#1da1f2"
            :href="
              `https://twitter.com/intent/tweet?text=I%20just%20created%20an%20account%20on%Tippings.%20Check%20out%20my%20Tippings%20page%20https://tippings.me/${username}`
            "
            target="_blank"
          
            style="color:white"
            class='mt-3 animate__animated animate__fadeInUp animate__delay-2s'
            width="420px"
          >
            <v-icon color="white" class="mr-2 px-4">mdi-twitter</v-icon>
            Share on Twitter
          </v-btn>
          </div>
          <div>
          <v-btn
            x-large
            color="#2663ac"
            :href="
              `https://www.linkedin.com/shareArticle?mini=true&title=I%20just%20created%20an%20account%20on%Tippings.%20Check%20out%20my%20Tippings%20page%20https://tippings.me/${username}`
            "
            target="_blank"
            style="color:white"
             class='mt-3 animate__animated animate__fadeInUp animate__delay-3s'
             width="420px"
          >
            <v-icon color="white" class="mr-2 px-2">mdi-linkedin</v-icon>
         Share on LinkedIn </v-btn>
         </div>
              </div>
              </div>
            </div>
          </v-container>
        </v-col>
      </v-row>
    </v-main>

    <!-- Phone view -->
    <v-main class="hidden-lg-and-up pa-3 pt-5" style="margin-bottom:100px">
    <v-btn @click="goBack()" text margin="10px"><v-icon>mdi-chevron-left</v-icon>Back</v-btn>
      <v-container>
        <span
          class="font-weight-bold"
          style="padding-top:0px;text-decoration:none;font-size:20px"
        >
          Share</span
        >

        <div style="margin-left:0px;max-width:740px">
         <p>Share your Tipppings page with your friends and connections:</p>
              <div>
              <div>
              <v-btn
            x-large
            color="#1773ea"
            :href="`https://facebook.com/sharer/sharer.php?u=https://tippings.me/${username}`"
            target="_blank"
            style="color:white"
             class="animate__animated animate__fadeInUp"
             block

          >
            <v-icon color="white" class="mr-2 px-2">mdi-facebook</v-icon>
           Share on Facebook
          </v-btn>
          </div>
          <div>
          <v-btn
            x-large
            color="green"
            :href="
              `https://wa.me/?text=I%20just%20created%20an%20account%20on%20Tippings.%20Check%20out%20my%20Tippings%20page!%20https://tippings.me/${username}`
            "
            target="_blank"
            block
            style="color:white"
            class='mt-3 animate__animated animate__fadeInUp animate__delay-1s'
          >
            <v-icon color="white" class="mr-2 px-2">mdi-whatsapp</v-icon>
          Share on WhatsApp</v-btn>
          </div>
          <div>
          <v-btn
            x-large
            color="#1da1f2"
            :href="
              `https://twitter.com/intent/tweet?text=I%20just%20created%20an%20account%20on%Tippings.%20Check%20out%20my%20Tippings%20page%20https://tippings.me/${username}`
            "
            target="_blank"
          
            style="color:white"
            class='mt-3 animate__animated animate__fadeInUp animate__delay-2s'
            block
          >
            <v-icon color="white" class="mr-2 px-4">mdi-twitter</v-icon>
            Share on Twitter
          </v-btn>
          </div>
          <div>
          <v-btn
            x-large
            color="#2663ac"
            :href="
              `https://www.linkedin.com/shareArticle?mini=true&title=I%20just%20created%20an%20account%20on%Tippings.%20Check%20out%20my%20Tippings%20page%20https://tippings.me/${username}`
            "
            target="_blank"
            style="color:white"
             class='mt-3 animate__animated animate__fadeInUp animate__delay-3s'
            block
          >
            <v-icon color="white" class="mr-2 px-2">mdi-linkedin</v-icon>
         Share on LinkedIn </v-btn>
         </div>
              </div>
              </div> 
      </v-container>
    </v-main>

    <BottomMenu class="hidden-lg-and-up" />

    
  </v-app>
</template>

<script>
import NavMenu from '@/components/NavMenu'
import BottomMenu from '@/components/BottomMenu'
import { mapState, mapGetters } from 'vuex'
import { getAuth, signOut, onAuthStateChanged } from 'firebase/auth'

export default{
  data(){
      return{

      }
  },
  components:{
      NavMenu,
      BottomMenu
  },
  computed:{
    ...mapState({
      loading:"loading",
      userData:"userData",
      walletBalance:"walletBalance",
      activities:"activities",
      bankDetails:"bankDetails",
      subscribers:"subscribers",
      notifications:"notifications",
      username:"username"

    }),
    ...mapGetters({
      user: "user",
    }),
  },
  
  beforeCreate() {
    if(localStorage.getItem('tippingsKey') == null){
     const auth = getAuth();
      signOut(auth)
        .then(() => {
          this.$router.push('/login')
        })
        .catch((error) => {
          console.log(error);
        });
   }
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      this.person =  user
      if (!user) {
        this.$router.push("/login");
      }
    });
  },

  methods:{
      goBack(){
          this.$router.go(-1)
      }
  }
}

</script>